import { LOGO_URL } from "@/data/content";

export const Logo = ({ className = "h-11 w-auto" }) => (
  <img
    src={LOGO_URL}
    alt="South Icon Awards"
    className={`${className} object-contain bg-white rounded-lg p-1`}
    data-testid="brand-logo"
  />
);
